/**
 * Snap a date to the nearest 15-minute interval
 * @param date The date to snap
 * @returns A new date snapped to the nearest 15-minute interval
 */
export const snapToQuarterHour = (date: Date): Date => {
  const snapped = new Date(date);
  const minutes = snapped.getMinutes();
  const roundedMinutes = Math.round(minutes / 15) * 15;
  
  // Handle edge case where rounding to 60 minutes
  if (roundedMinutes === 60) {
    snapped.setHours(snapped.getHours() + 1);
    snapped.setMinutes(0, 0, 0);
  } else {
    snapped.setMinutes(roundedMinutes, 0, 0);
  }
  
  return snapped;
};

/**
 * Round a date down to the nearest 15-minute interval
 * @param date The date to round down
 * @returns A new date rounded down to the nearest 15-minute interval
 */
export const floorToQuarterHour = (date: Date): Date => {
  const floored = new Date(date);
  const minutes = floored.getMinutes();
  const flooredMinutes = Math.floor(minutes / 15) * 15;
  floored.setMinutes(flooredMinutes, 0, 0);
  return floored;
};

/**
 * Round a date up to the nearest 15-minute interval
 * @param date The date to round up
 * @returns A new date rounded up to the nearest 15-minute interval
 */
export const ceilToQuarterHour = (date: Date): Date => {
  const ceiled = new Date(date);
  const minutes = ceiled.getMinutes();
  const ceiledMinutes = Math.ceil(minutes / 15) * 15;
  
  // Handle edge case where ceiling to 60 minutes
  if (ceiledMinutes === 60) {
    ceiled.setHours(ceiled.getHours() + 1);
    ceiled.setMinutes(0, 0, 0);
  } else {
    ceiled.setMinutes(ceiledMinutes, 0, 0);
  }
  
  return ceiled;
};